import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/terms.css";
import { useEffect } from "react";
import { supabase } from "../supabase";



function FeasibilityTermsPage({ language = "en" }) {
  const navigate = useNavigate();
  const [agree, setAgree] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const { data } = await supabase.auth.getSession();

      if (!data.session) {
        navigate("/login", { replace: true });
      } else {
        setChecking(false);
      }
    };

    checkAuth();
  }, [navigate]);

  const t = useMemo(() => {
    const d = {
      en: {
        title: "Terms & Conditions",
        sub: "Please read and accept the following terms before proceeding to payment.",
        accept: "I have read and agree to the terms.",
        continue: "Continue to Payment",
        back: "Back",
        sections: [
          {
            h: "1) Scope of Work",
            p: [
              "The service provides an  feasibility study based on information supplied by the client and reasonable market/financial assumptions.",
              "Deliverables may include: executive summary, market overview, technical/operational assumptions, financial model, sensitivity analysis, and key risks.",
            ],
          },
         {
  h: "2) Client Responsibilities",
  p: [
    "The client is responsible for providing accurate, complete, and timely data and clarifying requirements.",
    "The client should provide all requested survey information whenever possible, as complete data helps improve the accuracy and quality of the study.",
    "Any delays or missing data may affect the timeline and outputs.",
  ],
},
          {
            h: "3) Assumptions & Limitations",
            p: [
              "Results depend on assumptions and input data; outcomes are not guaranteed.",
              "The study is advisory and does not constitute legal, tax, or regulatory advice.",
            ],
          },
          // {
          //   h: "4) Revisions",
          //   p: [
          //   //   "Includes up to two reasonable revision cycles (within the agreed scope).",
          //     "Major scope changes may require a revised quotation.",
          //   ],
          // },
          {
            h: "4) Confidentiality",
            p: [
              "All information shared by the client is treated as confidential and used only to deliver the service.",
            ],
          },
          {
            h: "5) Payment & Start of Work",
            p: [
              "Work begins only after payment confirmation (or as per the agreed payment terms).",
              "If payment is not completed, delivery timelines will not be guaranteed.",
            ],
          },
          {
            h: "6) Cancellation & Refunds",
            p: [
              "Before work starts: refund may be possible (minus processing fees if any).",
              "After work starts: refunds depend on completed work and delivered materials.",
            ],
          },
          {
            h: "7) Intellectual Property",
            p: [
              "Deliverables are provided for the client’s Exclusive use unless otherwise agreed in writing.",
              "Redistribution or resale is not allowed without written permission.",
            ],
          },
        ],
      },
      ar: {
        title: "الشروط والأحكام",
        sub: "يرجى قراءة الشروط والموافقة عليها قبل الانتقال إلى الدفع.",
        accept: "قرأت الشروط وأوافق عليها.",
        continue: "المتابعة إلى الدفع",
        back: "رجوع",
        sections: [
          {
            h: "1) نطاق العمل",
            p: [
              "تقديم دراسة جدوى اعتمادًا على المعلومات المقدمة من العميل وافتراضات سوقية/مالية معقولة.",
              "قد تشمل المخرجات: ملخص تنفيذي، نظرة سوقية، افتراضات تشغيلية/فنية، نموذج مالي، تحليل حساسية، وأهم المخاطر.",
            ],
          },
       {
  h: "2) مسؤوليات العميل",
  p: [
    "العميل مسؤول عن تزويد بيانات دقيقة وكاملة وفي الوقت المناسب وتوضيح المتطلبات.",
    "يُرجى توفير جميع المعلومات المطلوبة في الاستبيان قدر الإمكان، لأن اكتمال البيانات يساعد على تحسين دقة وجودة الدراسة.",
    "أي تأخير أو نقص في البيانات قد يؤثر على الجدول الزمني وجودة المخرجات.",
  ],
},
          {
            h: "3) الافتراضات والقيود",
            p: [
              "تعتمد النتائج على الافتراضات والبيانات المدخلة ولا يوجد ضمان لنتائج أو أرباح مستقبلية.",
              "الدراسة استشارية ولا تعتبر استشارة قانونية أو ضريبية أو تنظيمية.",
            ],
          },
          // {
          //   h: "4) التعديلات",
          //   p: [
          //   //   "يشمل العمل دورتين تعديل معقولتين ضمن نطاق الاتفاق.",
          //     "أي تغيير كبير في نطاق العمل قد يتطلب عرض سعر جديد.",
          //   ],
          // },
          {
            h: "4) السرية",
            p: [
              "تُعامل جميع المعلومات التي يقدمها العميل بسرية وتُستخدم فقط لتنفيذ الخدمة.",
            ],
          },
          {
            h: "5) الدفع وبداية العمل",
            p: [
              "يبدأ العمل بعد تأكيد السداد (أو حسب شروط الدفع المتفق عليها).",
              "في حال عدم إتمام الدفع لا يمكن ضمان مواعيد التسليم.",
            ],
          },
          {
            h: "6) الإلغاء والاسترجاع",
            p: [
              "قبل بدء العمل: يمكن النظر في الاسترجاع (مع خصم رسوم المعالجة إن وجدت).",
              "بعد بدء العمل: يكون الاسترجاع حسب ما تم إنجازه وما تم تسليمه.",
            ],
          },
          {
            h: "7) حقوق الملكية الفكرية",
            p: [
              "تُسلم المخرجات للاستخدام الحصري للعميل ما لم يتم الاتفاق خطيًا على خلاف ذلك.",
              "لا يجوز إعادة نشرها أو بيعها دون موافقة.",
            ],
          },
        ],
      },
    };
    return d[language] || d.en;
  }, [language]);

  const onContinue = () => {
    localStorage.setItem("terms_feasibility_accepted", "true");
    localStorage.setItem("terms_feasibility_accepted_at", new Date().toISOString());
    navigate("/payment");
  };
console.log("🔥 ENTER TERMS PAGE");
  return (
   <section
  className={`terms-section ${language === "ar" ? "rtl" : ""}`}
  dir={language === "ar" ? "rtl" : "ltr"}
  lang={language}
>
      <div className="terms-card">
        <h1 className="terms-title">{t.title}</h1>
        <p className="terms-sub">{t.sub}</p>

        <div className="terms-content">
          {t.sections.map((s, i) => (
            <div key={i} className="terms-block">
              <h3 className="terms-h3">{s.h}</h3>
              <ul className="terms-list">
                {s.p.map((line, idx) => (
                  <li key={idx}>{line}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="terms-actions">
          <label className="terms-agree">
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <span>{t.accept}</span>
          </label>

          <div className="terms-buttons">
            <button
              type="button"
              className="terms-btn secondary"
              onClick={() => navigate(-1)}
            >
              {t.back}
            </button>

            <button
              type="button"
              className="terms-btn primary"
              disabled={!agree}
              onClick={onContinue}
            >
              {t.continue}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeasibilityTermsPage;